/**
 * Media Tabs — click handler for PDP product info tabs
 */
(function () {
  function initMediaTabs() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.media-tab-btn');
      if (!btn) return;

      var container = btn.closest('.media-tabs-container');
      if (!container) return;

      // Deactivate all buttons and panels in this container
      container.querySelectorAll('.media-tab-btn').forEach(function (b) {
        b.classList.remove('active');
      });
      container.querySelectorAll('.media-tabs-content').forEach(function (c) {
        c.classList.remove('active');
      });

      // Activate the clicked button
      btn.classList.add('active');

      // Activate the target panel
      var targetId = btn.getAttribute('data-target');
      var panel = container.querySelector('#' + targetId);
      if (panel) panel.classList.add('active');
    });
  }

  function cleanTrustedCheckout() {
    document.querySelectorAll('.product__info-container *').forEach(function (el) {
      if (el.children.length === 0 && el.innerText && el.innerText.trim().indexOf('Secure and trusted checkout') !== -1) {
        var parent = el.parentElement;
        if (parent) parent.style.display = 'none';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initMediaTabs();
      cleanTrustedCheckout();
    });
  } else {
    initMediaTabs();
    cleanTrustedCheckout();
  }
})();
